import { render, staticRenderFns } from "./CreateWorkGroup.vue?vue&type=template&id=787f791a&scoped=true&"
import script from "./CreateWorkGroup.vue?vue&type=script&lang=js&"
export * from "./CreateWorkGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787f791a",
  null
  
)

export default component.exports